import { navigate, RouteComponentProps } from "@reach/router"
// Styles
import { SimpleTable_s } from 'components/dashboard/dashboard-styles'
import folderService, { Folder } from "data/folder"
import { local } from 'data/lib/local-json'
// Data
import propertyService, { Property } from "data/property"
// Icons
import { CommercialIcon, HospitalityIcon, MFRentIcon, MixedUseIcon } from 'images/icons/sidebar'
import _ from "lodash"
import Moment from 'moment'
import React, { FC, useEffect, useState } from "react"
import Isvg from 'react-inlinesvg'

type FolderMap = {
  [key: number]: Folder
}

const RecentPropertiesWidget: FC<RouteComponentProps> = (props) => {
  const [folders, setFolders]       = useState<Folder[]>([]);
  const [folderMap, setFolderMap]   = useState<FolderMap>({})
  const [properties, setProperties] = useState<Property[]>([]);
  const [property, setProperty]     = useState<number|null>(local('property'));

  useEffect(() => {
    const folderSubscription = folderService.stream().subscribe(data => {
      setFolders(data.value as Folder[]);
      const map = _.transform(data.value, (map, f) => map[f.folderid] = f, {})
      setFolderMap(map)
    });

    folderService.fetchAllFolders()

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        if (data.current !== property) setProperty(data.current)
      }
    });

    return () => {
      propertySubscription.unsubscribe();
      folderSubscription.unsubscribe();
    }
  }, []);

  useEffect(() => {
    let recentProperties = local('recentProperties')?.filter(prop => prop['id']).map(prop => prop['id']) || null
    recentProperties && propertyService.fetchProperties(recentProperties).then((recentProps:any)=>{
      if (Array.isArray(recentProps)){
        const propsWithTime = recentProps.map(prop => { return {...prop, time: _.find(local('recentProperties'), {id: prop['propertyid']})['time']}}).sort(function (a, b) {
          return b.time.localeCompare(a.time);
        })
        setProperties(propsWithTime)
      }
    })
  }, [property]);

  const getPath = (property) => {
    const folderid = property.folderid
    let parent = _.find(folders, f => f.folderid == folderid)
    let path = `${parent?.code}/${property?.code}`
    while(parent = folderMap[parent?.parentfolder])
      path = `${parent?.code}/${path}`
    return path
  }

  function navigateTo(property:object):void {
    const currentFolderId = _.last(local('folderPath'))
    if (property['folderid'] !== currentFolderId){
      folderService.selectFolder(property['folderid'])
      setTimeout(() => { redirect(property) }, 600);
    } else redirect(property)
  }

  function redirect(property:object):void {
    propertyService.selectProperty(property['propertyid'])
    if (property['type'] === 'Multifamily') navigate('/n/multifamily/rent-roll')
    else if (property['type'] === 'Hospitality') navigate('/n/hospitality/rooms')
    else navigate('/n/rent-roll/home')
  }

  const commercialIcon  = <Isvg src={CommercialIcon} cacheGetRequests width={18} />;
  const hospitalityIcon = <Isvg src={HospitalityIcon} cacheGetRequests width={15} />;
  const mfIcon          = <Isvg src={MFRentIcon} cacheGetRequests width={13} />;
  const mixedUseIcon    = <Isvg src={MixedUseIcon} cacheGetRequests width={20} />;

  function humanize(num:number, precision:number):string {
    return Number(num).toLocaleString('en-US', {
      maximumFractionDigits: precision,
      notation: 'compact',
      compactDisplay: 'short'
    });
  }

  return (
    <SimpleTable_s>
      <thead>
        <tr>
          <th>Type</th>
          <th>Property</th>
          <th>Name</th>
          <th>Last Access</th>
          <th>Value</th>
          <th>Per Area</th>
        </tr>
      </thead>
      <tbody>
        {properties.map((property) => {
          let typeIcon = property && property['type'] === 'Multifamily' ? mfIcon : property && property['type'] === 'Hospitality' ? hospitalityIcon : property['type'] === 'Mixed-Use' ? mixedUseIcon : commercialIcon
          if (property){
            let { lastCalcValue, lastCalcValuePerArea } = _.find(property['valuationdetail'], 'defaultScenario') || {}
            if (!_.isNil(lastCalcValue) && !_.isNil(lastCalcValuePerArea)){
              lastCalcValuePerArea = humanize(Number(lastCalcValuePerArea), 2)
              lastCalcValue = humanize(Number(lastCalcValue), 2)
            } else {
              lastCalcValuePerArea = '-'
              lastCalcValue = '-'
            }
            return (
              <tr key={property['propertyid']}>
                <td className="icon-column">{typeIcon}</td>
                <td><a onClick={()=>navigateTo(property)}>{getPath(property)}</a></td>
                <td>{property['name'] || ''}</td>
                <td>{Moment(property['time']).format('MM/DD/YYYY h:mm A')} {property['timezone']}</td>
                <td>{lastCalcValue}</td>
                <td>{lastCalcValuePerArea}</td>
              </tr>
            )
          }})}
      </tbody>
    </SimpleTable_s>
  )
}

export default RecentPropertiesWidget